import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type GetBookmarkListResponce } from '../services/getBookmarkService'

export interface GetBookmarkDataState {
  isLoading: boolean
  loadingError: string | undefined
  getBookmarkData: GetBookmarkListResponce | undefined
  httpStatus: number | undefined
}

// Initial state of the slice
export const initialState: GetBookmarkDataState = {
  isLoading: false,
  loadingError: undefined,
  getBookmarkData: undefined,
  httpStatus: undefined
}

// Slice to return from action
export const GetBookmarkDataListState = createSlice({
  name: 'GetBookmarkData',
  initialState,
  reducers: {
    GetBookmarkDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        getBookmarkData: undefined,
        httpStatus: 0
      }
    },
    GetBookmarkDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        getBookmarkData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    GetBookmarkDataErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        getBookmarkData: undefined
      }
    },
    GetBookmarkDataReset: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: false,
        loadingError: undefined,
        getBookmarkData: undefined,
        httpStatus: 0
      }
    }
  }
})

// Actions to export
export const {
  GetBookmarkDataLoadingAction,
  GetBookmarkDataUpdateAction,
  GetBookmarkDataErrorAction,
  GetBookmarkDataReset
} = GetBookmarkDataListState.actions

export default GetBookmarkDataListState.reducer
